/**
 * Bring into this book (#900). Standing series snapshots.
 * Propose, accept, skip. Name-only match is not identity.
 */

export const THEME_CONTEXT_CATEGORY = 'series_theme_context';

export function isSeriesThemeContext(category) {
  return (category || '').trim().toLowerCase() === THEME_CONTEXT_CATEGORY;
}

export function remainingOffers(offers = [], done = {}) {
  return (offers || []).filter((row) => row?.id && !done[row.id]);
}
